import React, { Component } from "react";
import { isValidArray } from "../../helper";
import { isFunction, uniqBy } from "lodash";
import { connect } from "react-redux";
import { OverlayTrigger, Tooltip, Image } from "react-bootstrap";
import NodalOfficer from "../../assets/nodal.svg";
import { get } from "lodash";

export class SelectedGuestList extends Component {
  checkIfGuestExist = (selectedGuests, guestListData) => {
    let idsArr =
      guestListData && guestListData.length
        ? guestListData.map(item => item.userId)
        : [];
    let guests =
      selectedGuests &&
      selectedGuests.length &&
      selectedGuests.filter(item => idsArr.includes(item.userId));
    return guests;
  };

  deleteSelectedGuests = emailType => {
    const { selectedGuests, deleteGuests } = this.props;
    for (let i = selectedGuests.length - 1; i >= 0; i--) {
      if (
        selectedGuests[i].emailType === emailType &&
        !selectedGuests[i].userAddedGuest
      ) {
        const userId = selectedGuests[i].userId;
        deleteGuests(userId);
      }
    }
  };

  removeDuplicateGuests(arr) {
    return arr.reduce((acc, curr) => {
      const duplicate = acc.find(item => item.userId === curr.userId);
      if (!duplicate) {
        acc.push(curr);
      }
      return acc;
    }, []);
  }

  render() {
    const { selectedGuests, deleteGuests, guestListData } = this.props;

    const uniqueGuestList =
      selectedGuests && this.removeDuplicateGuests(selectedGuests);

    let _guestListData = guestListData && guestListData.data;
    const guests =
      (isValidArray(uniqueGuestList) &&
        this.checkIfGuestExist(uniqueGuestList, _guestListData)) ||
      [];
    let to = 0,
      cc = 0;
    guests.forEach(data => {
      if (data.emailType === "TO") {
        to++;
      }
      if (data.emailType === "CC") {
        cc++;
      }
    });
    {
      console.log(guests, "name");
    }

    return (
      <>
        <div class="guest-selected-list-container">
          <div class="selected-list">
            <div> Selected Guest(s) List </div>
          </div>
          <div className="guest-list-to">
            <div>
              <div className="d-flex justify-content-between">
                <div className="guest-list-heading">
                  TO: {to < 10 ? "0" + to : to} Guest
                </div>
                <div
                  className="guest-clear-all"
                  onClick={() => this.deleteSelectedGuests("TO")}
                >
                  Clear All
                  <div class="horizontal-line" />
                </div>
              </div>
              {guests.length >= 1 && (
                <div className="guest-name">
                  {uniqBy(guests, "userId").map((value, index) => {
                    return (
                      <>
                        {value.emailType === "TO" && (
                          <div
                            className="selected-guest-list justify-content-between"
                            key={`selected-guest-${index}`}
                          >
                            <OverlayTrigger
                              placement="bottom-start"
                              overlay={
                                <Tooltip
                                  id="tooltip-pdf"
                                  placement="bottom-start"
                                  className={`issues-actions-tooltip ${""}`}
                                >
                                  <div className="tooltip-align">{`${get(
                                    value,
                                    "designation",
                                    "NA"
                                  )}`}</div>
                                  <div className="user-group-name">{`(${get(
                                    value,
                                    "groupName",
                                    "NA"
                                  )})`}</div>
                                </Tooltip>
                              }
                            >
                              <div className="selected-guest-name d-flex">
                                {value.nodalOfficer === true ? (
                                  <Image
                                    src={NodalOfficer}
                                    className="nodal-officer-icon mr-1"
                                  />
                                ) : null}
                                {value.userName}
                              </div>
                            </OverlayTrigger>
                            <div
                              className="unselect-guest"
                              onClick={() => {
                                isFunction(deleteGuests) &&
                                  deleteGuests(value.userId);
                              }}
                            />
                          </div>
                        )}
                      </>
                    );
                  })}
                </div>
              )}
            </div>
            <div className="cc-guest-list">
              <div className="d-flex justify-content-between">
                <div className="guest-list-heading">
                  CC: {cc < 10 ? "0" + cc : cc} Guest
                </div>
                <div
                  className="guest-clear-all"
                  onClick={() => this.deleteSelectedGuests("CC")}
                >
                  Clear All
                  <div class="horizontal-line" />
                </div>
              </div>
              <div className="guest-name">
                {uniqBy(guests, "userId").map((value, index) => {
                  return (
                    <>
                      {value.emailType === "CC" && (
                        <div
                          className="selected-guest-list justify-content-between"
                          key={`selected-guest-${index}`}
                        >
                          <OverlayTrigger
                            placement="bottom-start"
                            overlay={
                              <Tooltip
                                id="tooltip-pdf"
                                placement="bottom-start"
                                className={`issues-actions-tooltip  ${""}`}
                              >
                                <div className="tooltip-align">{`${get(
                                  value,
                                  "designation",
                                  "NA"
                                )}`}</div>
                                <div className="user-group-name">{`(${get(
                                  value,
                                  "groupName",
                                  "NA"
                                )})`}</div>
                              </Tooltip>
                            }
                          >
                            <div className="selected-guest-name d-flex">
                              {value.nodalOfficer === true ? (
                                <Image
                                  src={NodalOfficer}
                                  className="nodal-officer-icon mr-1"
                                />
                              ) : null}
                              {value.userName}
                            </div>
                          </OverlayTrigger>
                          <div
                            className="unselect-guest"
                            onClick={() => {
                              isFunction(deleteGuests) &&
                                deleteGuests(value.userId);
                            }}
                          />
                        </div>
                      )}
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    guestListData: state.issueActionReducer.guestListData
  };
}

export default connect(
  mapStateToProps,
  null
)(SelectedGuestList);
